
import { Component, Input} from '@angular/core';
import { Svgs } from '../base/base.component';
import { IContractStateContext } from '../state-context/state-context.interface';
import { IContractState } from '../state.interface';
// -----------------------------------------------------------------------------------------
@Component({
  templateUrl: './received.state.html'
})
export class ReceivedStateComponent implements IContractState {
  svg : Svgs = Svgs.DoneOutline
  @Input() context!: IContractStateContext;
  // -----------------------------------------------------------------------------------------
  nextState(): void {

  }
}

